<template>
  <div class="gifts-form" :class="{ 'gifts-form--nested': nested }">
    <div
      v-for="(slot, idx) in giftSlots"
      :key="idPrefix + idx"
      class="gift-field"
      :class="{ 'is-locked': giftLockFlags[idx] && giftLockFlags[idx].locked }"
    >
      <div class="gift-label-row">
        <label class="gift-label" :for="idPrefix + idx">Gift {{ idx + 1 }}</label>
        <span
          v-if="giftLockFlags[idx] && giftLockFlags[idx].locked"
          class="gift-used-pill"
          :title="giftLockFlags[idx].reason"
        >Used</span>
      </div>
      <select
        :id="idPrefix + idx"
        :value="giftSlots[idx]"
        class="gift-select"
        :disabled="giftLockFlags[idx] && giftLockFlags[idx].locked"
        @change="$emit('select', idx, $event)"
      >
        <option value="Not Yet Selected">Choose a gift…</option>
        <option
          v-for="opt in options"
          :key="opt"
          :value="opt"
        >
          {{ opt }}
        </option>
        <option value="None">None / skip this slot</option>
      </select>
      <p
        v-if="giftLockFlags[idx] && giftLockFlags[idx].locked"
        class="gift-lock-reason"
      >
        {{ giftLockFlags[idx].reason }}
      </p>
    </div>

    <p v-if="giftError" class="gift-error" role="alert">{{ giftError }}</p>
    <p v-if="giftSuccess" class="gift-success" role="status">{{ giftSuccess }}</p>

    <button
      type="button"
      class="iabf-btn iabf-btn--primary gift-save"
      :disabled="giftSaving || !giftsDirty"
      @click="$emit('save')"
    >
      {{ giftSaving ? 'Saving…' : 'Save gifts' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'RegistrationGiftPicker',
  props: {
    giftSlots: {
      type: Array,
      default: () => []
    },
    giftLockFlags: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    giftError: {
      type: String,
      default: ''
    },
    giftSuccess: {
      type: String,
      default: ''
    },
    giftSaving: {
      type: Boolean,
      default: false
    },
    giftsDirty: {
      type: Boolean,
      default: false
    },
    idPrefix: {
      type: String,
      default: 'gift-slot-'
    },
    nested: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.gifts-form {
  padding: 20px 18px;
  background: #fff;
  border: 1.5px solid var(--iabf-border, #e3e0e8);
  border-radius: 16px;
}
.gifts-form--nested {
  padding: 16px 14px;
}
.gift-field {
  margin-bottom: 14px;
}
.gift-field.is-locked .gift-select {
  background: var(--iabf-bg-soft, #eef0eb);
  color: var(--iabf-ink-muted, #5c5a63);
  cursor: not-allowed;
}
.gift-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.gift-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--iabf-ink-faint, #8a8792);
  margin-bottom: 0;
}
.gift-used-pill {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(138, 149, 125, 0.2);
  color: var(--iabf-primary, #8a957d);
}
.gift-lock-reason {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.35;
  color: var(--iabf-ink-faint, #8a8792);
}
.gift-select {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1.5px solid var(--iabf-border, #e3e0e8);
  border-radius: 12px;
  font-family: var(--iabf-font-body, inherit);
  font-size: 16px;
  color: var(--iabf-ink, #1c1b1f);
  background: #fff;
}
.gift-select:focus {
  outline: none;
  border-color: var(--iabf-primary, #8a957d);
  box-shadow: 0 0 0 3px var(--iabf-focus-ring, rgba(138, 149, 125, 0.35));
}
.gift-select:disabled {
  opacity: 1;
}
.gift-error {
  color: var(--iabf-danger, #b54a4a);
  font-size: 14px;
  margin: 8px 0 0;
}
.gift-success {
  color: var(--iabf-success, #5f7a55);
  font-size: 14px;
  margin: 8px 0 0;
}
.gift-save {
  margin-top: 12px;
}
.gift-save:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>

